<template>
	<div v-if="requests.length" class="tp-RepairView__entry is-materialRequests">
		<h2 class="title">Material Pedido</h2>

		<div class="content">
			<MaterialRequestsTableReact :requests="requests" />
		</div>
	</div>
</template>

<script>
import { addDays, addWeeks, format } from "date-fns/esm/fp";
import ReactInVue from "@/components/logic/wrappers/ReactInVue";
import { MaterialRequestsTable } from "@/components/repair/MaterialRequestsTable";
import { DATE_DAY_FROM_MONTH } from "@/services/formatters";

// time margins for each origin
const dateMarginForEurope = addDays(4);
const dateMarginWordStart = addWeeks(2);
const dateMarginWordEnd = addWeeks(6);

const MaterialRequestsTableReact = ReactInVue(MaterialRequestsTable);

export default {
	components: {
		MaterialRequestsTableReact,
	},
	name: "MaterialRequests",

	props: {
		repair: {
			type: String,
			default: null,
		},
	},

	data() {
		return {
			requests: [],
		};
	},

	created() {
		this.fetchData();
	},

	methods: {
		async fetchData() {
			// get material requests for a given repair
			const { requests } = await this.$stellar.action(
				"materialRequestsForRepair",
				{
					repair: this.repair,
				},
			);

			// save the requests
			this.requests = requests;
		},
		/**
		 * Format the estimated delivery date interval.
		 */
		estimateDelivery(purchase) {
			let startDate = null;
			let endDate = null;

			if (purchase.origin === "europe") {
				startDate = new Date(purchase.createdAt);
				endDate = dateMarginForEurope(new Date(purchase.createdAt));
			} else {
				startDate = dateMarginWordStart(new Date(purchase.createdAt));
				endDate = dateMarginWordEnd(new Date(purchase.createdAt));
			}

			// format date
			const dateFormatter = format(DATE_DAY_FROM_MONTH);
			startDate = dateFormatter(startDate);
			endDate = dateFormatter(endDate);

			return `(${startDate} - ${endDate})`;
		},
	},
};
</script>

<style lang="scss">
.tp-RepairView__entry.is-materialRequests {
	max-width: 97%;
	margin: 20px auto;
	padding: 25px 40px;
}
</style>
